import React, { InputHTMLAttributes } from 'react';
import cx from 'classnames';

export interface InputProps
  extends Pick<
    InputHTMLAttributes<HTMLInputElement>,
    'placeholder' | 'name' | 'onChange' | 'className' | 'type' | 'disabled'
  > {
  value?: string;
  defaultValue?: string;
  inputRef?: React.Ref<HTMLInputElement> | null;
}

export function Input({
  inputRef,
  disabled,
  className,
  ...inputProps
}: InputProps) {
  return (
    <input
      ref={inputRef}
      disabled={disabled}
      {...inputProps}
      className={cx(
        className,
        [
          'v2-w-full v2-border v2-border-neutral-300 v2-border-solid v2-text-neutral-900',
          'v2-h-10 v2-text-base v2-px-4 v2-outline-none placeholder:v2-text-neutral-300',
        ],
        {
          'hover:!v2-border-yellow-500 focus:!v2-border-yellow-500': !disabled,
          'v2-text-neutral-500': disabled,
        }
      )}
    />
  );
}
